
export default {
    props: {
        idOrNameOrAgent: {
            type: [Number, String, Object],
            default: null
        },
        agentActive: {
            type: Boolean,
            default: null
        }
    },
    data () {
        return {
            agent: null
        }
    },
    async fetch () {
        if (typeof this.idOrNameOrAgent === 'object') {
            this.agent = this.idOrNameOrAgent
            return
        }
        if (typeof this.idOrNameOrAgent === 'string') {
            this.agent = {
                first_name: this.idOrNameOrAgent,
                last_name: '',
                active: this.agentActive == null ? this.agentActive : this.agentActive
            }
            return
        }
        this.agent = await this.$try('getClientAgent', this.idOrNameOrAgent)
    },
}
